import dataApi from '../'

export default {

  /**
  * Get the campaigns units
  */
  getCampaignsUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/campaigns-unit',
      params: params
    })
  },
  /**
   * Get the campaigns units master data
   */
  getCampaignsUnitMaster (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/campaigns-unit-master',
      params: params
    })
  },
  /**
   * Get the campaigns units group details
   */
  getCampaignsUnitGroupDetails (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/campaigns-unit-group-details',
      params: params
    })
  },
  /**
  * Get workflow overview
  */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/overview',
      params: params
    })
  },

  /**
  * Get workflows based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/search',
      params: params
    })
  },

  /**
  * Delete workflow
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/cit/delete',
      params: params
    })
  },

  /**
  * Get the workflow info for edit
  */
  getInforForEdit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/info-for-edit',
      params: params
    })
  },

  /**
  * Add workflow
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/cit/add-workflow',
      body: params
    })
  },

  /**
  * Edit workflow
  */
  putEdit (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/cit/update-workflow',
      body: params
    })
  },

  /**
  * Get the workflow info for edit
  */
  getWorkflowPages (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/get-pages',
      params: params
    })
  },

  /**
  * Get the workflow list for unit
  */
  getWorkflows (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/workflows',
      params: params
    })
  },

  getWorkflowExport (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/cit/export-workflow?workflowId=' + params,
      accept: 'application/xml'
    })
  },

  postImportWorkflow (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/cit/import-workflow',
      body: params,
      headers: {'Content-type': 'multipart/form-data'}
    })
  },

  /**
  * Get the placeholders for unit
  */
  getPlaceholdersAndActions (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/v2/placeholder/placeholders-and-placeholder-actions/' + params
    })
  },

  /**
   * Get all placeholder conditions
   */
  getPlaceholderConditions () {
    return dataApi.request({
      method: 'get',
      url: 'ui/v2/placeholder-conditions'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/cit.js